import React, {Component} from "react";
import SectionTitle from "../SectionTitle"
import "./SliderStyles.css"
import ImageSlider from "./ImageSlider";
import FancyNavigation from "../ScrollSpyPagination/PaginationNavigation";

class Slider extends Component {
    render() {
        return(
            <div className={"slider"}>
                <FancyNavigation />
                <ImageSlider />
            </div>
        );
    }
}
export default Slider;